module.exports = __webpack_public_path__ + "images/map/map-marker-white-914d14a704505bf58998e369ec6b9935.svg";